import { Icon } from "@storeblocks/icon";
import LoadingIndicator from "@storeblocks/loading-indicator";
import { CurrentPriceMessageContainer } from "Components/CurrentPriceMessage/styles";
import { TextManager } from "Components/TextContext";
import { formatToLocaleString } from "Formatting/formatNumber";
import React, { ReactElement } from "react";

interface Props {
  monthlyPrice: number;
  yearlyPrice: number;
  isLoading?: boolean;
}

export const CurrentPriceMessageContent = ({
  monthlyPrice,
  isLoading = false,
}: Props): ReactElement => {
  const { getText } = TextManager;
  return (
    <CurrentPriceMessageContainer className="current-price-message">
      <Icon name="hand-discount" size={48} />
      <span>
        {getText("common.price.currentpricemessage.prefix")}{" "}
        <b>
          {!isLoading ? (
            getText("common.price.permonth", {
              variables: {
                monthlyPrice: formatToLocaleString(monthlyPrice),
              },
            })
          ) : (
            <LoadingIndicator color="on-surface" size="small" />
          )}
        </b>{" "}
        {getText("common.price.currentpricemessage.suffix")}
      </span>
    </CurrentPriceMessageContainer>
  );
};
